import React from 'react';

import { getShortenedNumber } from '@eventbrite/eds-utils';
import { gettext } from '@eventbrite/i18n';
import { numberFormatter } from '../utils/utils';

import {
    FOLLOWERS_THRESHOLD,
    TOTAL_RATING_THRESHOLD,
} from '../_shared/constants';

import StarIcon from '../_shared/OrganizerInfo/RatingInfo/StarIcon';

import type { TSignalContentList } from '../_shared/OrganizerInfo/ListingSignals';

const _addRatingSignalSafe = (
    signalsData: TSignalContentList,
    starRatingCount: number,
    totalRatingCount: number,
) => {
    if (totalRatingCount > TOTAL_RATING_THRESHOLD) {
        signalsData.push({
            id: 'star-rating',
            countEl: (
                <div className="eds-align--center">
                    <StarIcon />
                    <span>{starRatingCount.toFixed(1)}</span>
                </div>
            ),
            title: `${gettext('Ratings')} (${numberFormatter(
                totalRatingCount,
            )})`,
            testId: 'ratings-count',
        });
    }
};

const _addFollowerSignalSafe = (
    signalsData: TSignalContentList,
    followCount: number,
) => {
    if (followCount > FOLLOWERS_THRESHOLD) {
        signalsData.push({
            id: 'follow-count',
            countEl: getShortenedNumber(followCount),
            title: gettext('Followers'),
            testId: 'followers-count',
        });
    }
};

export const useListingSignals = (
    followCount: number,
    starRatingCount: number,
    totalRatingCount: number,
) => {
    const [signals, setSignals] = React.useState<TSignalContentList>([]);

    React.useEffect(() => {
        const _signals: TSignalContentList = [];
        _addRatingSignalSafe(_signals, starRatingCount, totalRatingCount);
        _addFollowerSignalSafe(_signals, followCount);
        setSignals(_signals);
    }, [followCount, starRatingCount, totalRatingCount]);

    return signals;
};
